var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-layout"},[(_vm.account)?_c('Header',{attrs:{"account":_vm.account}}):_vm._e(),_c('div',{staticClass:"content"},[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }